import React from 'react';
import { useLanguage } from './Locale';
import './language.css';

export const LanguageSwitch = ({ id = 'app-language-switch', prominent = false }) => {
  const { language, setLanguage } = useLanguage();
  const spanish = language !== 'es';
  return <button type="button" className={`language-switch${prominent ? ' language-switch-prominent' : ''}`} data-testid={id}
    onClick={() => setLanguage(spanish ? 'es' : 'en')} lang={spanish ? 'es' : 'en'}
    aria-label={spanish ? 'Cambiar la aplicación a español' : 'Switch the application to English'}>
    {spanish ? <span className="spanish-flag" aria-hidden="true" data-testid={`${id}-flag`} /> : <span aria-hidden="true">EN</span>}
    {spanish ? 'Español' : 'English'}
  </button>;
};